import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import { useParams, Link } from "react-router-dom";
import Sidebar from "../../../partials/aside/Sidebar";
import validateFormAddSitePublishers from "../../../../validtions/forms/site-publishers/add-site-publishers";
import httpService from "../../../../services/httpServices/httpServices";
import helperSpinner from "../../../../helpers/spinner";
import helperNumbers from "../../../../helpers/numbers";

function EditSitePublisher() {
  const [activeSitePublisher, setActiveSitePublisher] = useState(false);
  const [sitePublisher, setSitePublisher] = useState();
  const [categories, setCategories] = useState();
  const [typeAdvertise, setTypeAdvertise] = useState();
  const [tagHtml, setTagHtml] = useState("");
  const [message, setMessage] = useState();
  const history = useHistory();
  const params = useParams();
  const sitePublisherID = params.id;
  const typesAdvertise = ["بنری"];
  const [copied, setCopied] = useState(false);
  const [maxPriority, setMaxPriority] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getCategoriesSitePublisher().then(() => {
      getSitePublisher(sitePublisherID);
    });
  }, []);

  useEffect(() => {
    if (!categories) {
      return;
    }
    getMaxPrioritySitePublishers();
  }, [categories]);

  const getMaxPrioritySitePublishers = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const maxPriority = await sendRequestGetMaxPrioritySitePublishers();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setMaxPriority(maxPriority);
  };

  const sendRequestGetMaxPrioritySitePublishers = async () => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/site-publishers/max-priority",
        headersRequest
      );
    } catch (error) {
      setMessage({
        type_class: "alert alert-danger",
        text: error.response.data.message,
        class_icon: "fa fa-exclamation-triangle",
      });
      return false;
    }
    return result.data.data;
  };

  const getCategoriesSitePublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategoriesSitePublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    setCategories(categories);
  };

  const getSitePublisher = async (sitePublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitePublisher = await sendRequestGetSitePublisher(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    setSitePublisher(sitePublisher);
    setActiveSitePublisher(sitePublisher.sib_active);
    let scriptSrc;
    if (process.env.REACT_APP_STATE == "PRODUCTION") {
      scriptSrc =
        "https://unpkg.com/hilite-script-site-publisher@latest/dist/script.min.js";
    } else {
      scriptSrc = "http://localhost:3002/script/v1/script.js";
    }
    setTagHtml(
      `<script class="hilite-script" data-hilite="${sitePublisher.hashIDScript}" src="${scriptSrc}"></script>`
    );
  };

  const sendRequestGetCategoriesSitePublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoriesSitePublishers;
    try {
      categoriesSitePublishers = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return categoriesSitePublishers.data.data;
  };

  const sendRequestGetSitePublisher = async (publisherID) => {
    const headersRequest = getHeaderForRequest();
    let categoriesSitePublishers;
    try {
      categoriesSitePublishers = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/manage/site-publisher/" +
          publisherID,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return categoriesSitePublishers.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generateTagHtmlCategories = () => {
    let isChecked = "";
    return categories.map((categorySitePublisher, index) => {
      if (sitePublisher.categories.includes(categorySitePublisher.cas_name)) {
        isChecked = "checked";
      } else {
        isChecked = "";
      }
      return (
        <div key={index} className="col-12 col-sm-6 col-md-3  ">
          <span className="w-100 justify-content-between d-inline-flex align-items-center py-2">
            <span className="small font-weight-bold text-nowrap">
              {categorySitePublisher.cas_name}
            </span>
            <span>
              <label className="adl-switch">
                <input
                  type="checkbox"
                  defaultChecked={isChecked}
                  className="categories-site-publisher"
                  defaultValue={categorySitePublisher.cas_id}
                />
                <span className="adl-slider round"></span>
              </label>
            </span>
          </span>
        </div>
      );
    });
  };

  const generateTagHtmlTypeAdvertise = () => {
    let isChecked = "";
    return typesAdvertise.map((typeAdvertise, index) => {
      if (sitePublisher.types.includes(typeAdvertise)) {
        isChecked = "checked";
      } else {
        isChecked = "";
      }

      return (
        <>
          <div key={index} className="col-12 col-sm-6 col-md-3 ">
            <span className="w-100 justify-content-between d-inline-flex align-items-center py-2">
              <span className="small font-weight-bold text-nowrap">
                {typeAdvertise}
              </span>
              <span>
                <label className="adl-switch">
                  <input
                    type="checkbox"
                    className="type-advertise"
                    defaultChecked={isChecked}
                    defaultValue={index + 1}
                  />
                  <span className="adl-slider round"></span>
                </label>
              </span>
            </span>
          </div>
        </>
      );
    });
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const formData = getFormData();

    if (validateFormAddSitePublishers(formData) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validateFormAddSitePublishers(formData),
        class_icon: "fa fa-exclamation-triangle",
      });

      return;
    }

    formData.types = formData.type_advertise;
    formData.categories = formData.categories_site_publisher;
    formData.active = activeSitePublisher;

    delete formData.type_advertise;
    delete formData.categories_site_publisher;

    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const result = await sendRequestEditSitePublisher(formData);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!result) {
      return;
    }
    history.push("/manage/publishers/all");
  };

  const getFormData = () => {
    const url = document.getElementById("url").value;

    const checkBoxesCategoriesSitePublisher = document.querySelectorAll(
      ".categories-site-publisher:checked"
    );
    let categoriesSitePublisher = [];
    checkBoxesCategoriesSitePublisher.forEach((checkBox) => {
      if (checkBox.defaultValue) {
        categoriesSitePublisher.push(checkBox.defaultValue);
      }
    });

    const checkBoxesTypeAdvertise = document.querySelectorAll(
      ".type-advertise:checked"
    );
    let typeAdvertise = [];
    checkBoxesTypeAdvertise.forEach((checkBox) => {
      typeAdvertise.push(checkBox.defaultValue);
    });

    return {
      url: url,
      categories_site_publisher: categoriesSitePublisher,
      type_advertise: typeAdvertise,
      publisher_id: document.querySelector("#site-publisher").value,
      priority: document.querySelector("#priority").value,
    };
  };

  const sendRequestEditSitePublisher = async (formData) => {
    const headersRequest = getHeaderForRequest();

    try {
      await httpService.putRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        formData,
        headersRequest
      );
      return true;
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
  };

  const generateSitePublisher = () => {
    return (
      <form onSubmit={sendForm}>
        <div className="form-group">
          <label>آدرس سایت</label>
          <div className="d-flex">
            <input
              dir="ltr"
              type="text"
              id="url"
              defaultValue={sitePublisher.sib_url}
              className="form-control"
            />

            <div className="pr-2">
              <Link to={`/manage/page/all/${sitePublisherID}`}>
                <div className="btn btn-warning ">
                  <span className="pl-2">
                    <i className="fa fa-file" aria-hidden="true"></i>
                  </span>
                  <span>
                    <span>صفحات سایت</span>
                  </span>
                </div>
              </Link>
            </div>
          </div>
        </div>

        <div>
          <label>نوع تبلیغ</label>
          <div className="container-fluid">
            <div className="row alert alert-secondary">
              {generateTagHtmlTypeAdvertise()}
            </div>
          </div>
        </div>

        <div>
          <label>
            <span className="pl-2">اسکریپت</span>
            <span>
              <button
                className="btn btn-info"
                onClick={(e) => {
                  e.preventDefault();
                  navigator.clipboard.writeText(tagHtml);
                  setCopied(true);
                }}
              >
                <i className="fas fa-copy pl-2"></i>
                {copied ? "کپی شد" : " کپی  "}{" "}
              </button>
            </span>
          </label>
          <div dir="ltr" className="alert alert-secondary text-left">
            {tagHtml}
          </div>
        </div>

        <div className="form-group">
          <label>
            {" "}
            شماره کاربر نمایش دهنده (مالک وب سایت) اگر مالکیت وب سایت با شرکت
            باشد شماره کاربر نمایش دهنده را صفر قرار دهید
          </label>
          <input
            type="number"
            id="site-publisher"
            defaultValue={sitePublisher.sib_user_publisher_id}
            className="form-control"
            onWheel={(e) => e.target.blur()}
          />
        </div>

        <div className="py-2">
          <label className="pl-2">
            اولویت برای گروه نمایش دهنده خودکار{" "}
            {maxPriority && (
              <span>
                ( بالاترین اولویت سایت =
                {helperNumbers.toPersianNum(maxPriority)})
              </span>
            )}
          </label>
          <input
            type="number"
            onWheel={(e) => e.target.blur()}
            id="priority"
            className="form-control"
            defaultValue={sitePublisher.sib_priority}
          />
        </div>

        <div className="pb-2 d-flex align-items-center">
          <span className="pl-2">
            <label>فعال</label>
          </span>
          <span>
            <label className="adl-switch">
              <input
                name="active"
                type="checkbox"
                checked={activeSitePublisher}
                id="active"
                className="categories-site-publisher"
                onChange={() => {
                  setActiveSitePublisher(!activeSitePublisher);
                }}
              />
              <span className="adl-slider round"></span>
            </label>
          </span>
        </div>

        <button type="submit" className="btn btn-primary">
          ویرایش
        </button>

        <div>
          <label>دسته های صنفی</label>
          <div className="container-fluid">
            <div className="row alert alert-secondary">
              {generateTagHtmlCategories()}
            </div>
          </div>
        </div>
      </form>
    );
  };

  return (
    <>
      <Sidebar openItem="manage-category-publisher-menu" />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  ویرایش سایت نمایش دهنده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <div className="d-flex justify-content-between">
                <div className="alert alert-warning">
                  <span>
                    <i className="fa fa-exclamation-circle text-white"></i>
                  </span>
                  <span className="pr-2  text-dark">
                    آدرس سایت باید با https و بدون صفحه و آخرین حرف فاقد "/"
                    باشد. مثال https://monirlock.ir
                  </span>
                </div>
                <Link className="text-white" to={`/manage/publishers/all`}>
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>

              {sitePublisher && generateSitePublisher()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default EditSitePublisher;
